import {
  BLOGS_GET_ALL,
  BLOGS_ADD_NEW,
  BLOGS_UPDATE,
  BLOGS_DELETE,
  BLOGS_GET_COMMENTS,
  BLOG_DELETE_COMMENT,
  BLOG_DELETE_COMMENTS
} from '../actions/blogs'

import {
  API_BASE_URL,
  BLOGS_GET_ALL_URL,
  BLOGS_ADD_NEW_URL,
  BLOGS_UPDATE_URL,
  BLOGS_DELETE_URL,
  BLOGS_GET_COMMENTS_URL,
  BLOG_DELETE_COMMENT_URL,
  BLOG_DELETE_COMMENTS_URL
} from "../variables"

import axios from 'axios'

const state = {};
const mutations = {};
const getters = {};
const actions = {
  [BLOGS_GET_ALL]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOGS_GET_ALL_URL,
      method: "GET",
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOGS_ADD_NEW]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOGS_ADD_NEW_URL,
      method: "POST",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOGS_UPDATE]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOGS_UPDATE_URL + payload.id,
      method: "PUT",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOGS_DELETE]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOGS_DELETE_URL + payload.id,
      method: "DELETE",
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOGS_GET_COMMENTS]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOGS_GET_COMMENTS_URL + payload.id + '/comments',
      method: "GET",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOG_DELETE_COMMENT]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOG_DELETE_COMMENT_URL + payload.id,
      method: "DELETE",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
  [BLOG_DELETE_COMMENTS]: ({commit, state, getters}, payload) => {
    return axios({
      url: API_BASE_URL + BLOG_DELETE_COMMENTS_URL + payload.id + '/comments/delete',
      method: "DELETE",
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + getters.getUserAccessToken
      }
    })
  },
}
export default {
  mutations,
  actions,
  getters,
  state
}